<template>
  <ul class="tags-list list-inline">
    <li
      v-for="(tag, index) in tags"
      :key="index"
      class="list-inline-item"
      @click="remove(tag)"
    >
      <tag :id="tag.id" :show-icon="true">
        {{ tag.name }}
      </tag>
    </li>
  </ul>
</template>

<script>
  import Tag from '../Tag/Tag'

  export default {
    components: { Tag },
    props: {
      tags: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      remove(tag) {
        this.$emit('remove', tag)
      },
    },
  }
</script>

<style lang="scss" src="./TagsList.scss"></style>
